/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState } from 'react';
import { StorageModule } from '@vlinder-web/storage-module-react';
//@ts-ignore
import { REACT_APP_BOOTSTRAP } from '@env';
import axios from 'axios';
import { useConstructor } from './constructor.hook';
import { LoggerModule } from '@vlinder-web/logger-module-react';
const is = require('is_js');
import { VApplication } from '../../application';

const MODULE_NAME = 'bootstrap-hook';
const log: any = LoggerModule?.getInstance({
  visible: false,
});

const _bootstrapHandler = async () => {
  await bootstrap();
  const vapp = VApplication.getInstance();
  await vapp.start();
  log?.success(MODULE_NAME, `🚀 Main Application Started 🚀`);

  //Do other config here !! Example: Sentry Initialization !!
};

const bootstrap = async () => {
  try {
    const storageService = StorageModule.getInstance();
    if (is.existy(storageService.get('appConfig', 'session'))) {
      return;
    }
    if (REACT_APP_BOOTSTRAP) {
      console.log('react app bootstrap', REACT_APP_BOOTSTRAP);
      const kv = await axios.get(REACT_APP_BOOTSTRAP);
      if (kv?.data) {
        storageService.set('appConfig', kv.data, 'session');
      }
    }
  } catch (err: any) {
    console.log('error in bootstrap', err?.message);
    throw Error(`error in bootstrap ${err?.message}`);
  }
};

export const useBootstrap = () => {
  const [bootstrap, setbootstrap] = useState<boolean>(false);

  useConstructor(_bootstrapHandler)
    .then((res) => {
      log.info(`bootstrap check`, res);
      setbootstrap(true);
    })
    .catch((err) => {
      log.error(`error in bootstrap  ${err.message}`);
      setbootstrap(true);
    });

  return { bootstrap };
};
